import ServiceSkuPage from './ServiceSkuPage';

export default ServiceSkuPage;
